// WinnerDialog.jsx
import React from "react";

const WinnerDialog = ({ winner, open, onClose }) => {
  if (!open || !winner) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "clamp(250px, 30vw, 400px)", // 가로만 반응형 설정
          padding: "1rem",
          borderRadius: "10px",
          textAlign: "center",
          boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h2 style={{ fontSize: "2rem", color: "#d32f2f", margin: 0 }}>
          🎉 당첨 결과!
        </h2>
        <p style={{ fontSize: "1.5rem", fontWeight: "bold", margin: "1.5rem 0" }}>
          {winner.name}
        </p>
        <button
          onClick={onClose}
          style={{
            padding: "0.75rem 2rem",
            fontSize: "1rem",
            cursor: "pointer",
            borderRadius: "6px",
            border: "none",
            backgroundColor: "#d32f2f",
            color: "white",
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};

export default WinnerDialog;
